export default "Aides rénovation tertiaire 2026 — CEE BAT, Coup de pouce CVC, suramortissement, Bpifrance | Solution Éco France";
